export { default } from './EnergiaSolarHeroMesAmbiente';
